var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fadeOut"}},[(_vm.tipsBool)?_c('div',{staticClass:"tips"},[_c('div',{staticClass:"center"},[_c('p',{staticClass:"tips-content"},[_vm._v("为响应国家政策，使用互联网服务需要进行帐号实名认证。为保障“评论”等功能的正常使用，请您注册完后，尽快到安全中心位置进行实名认证。")]),_vm._v(" "),_c('i',{staticClass:"icon",on:{"click":function($event){_vm.tipsBool=false}}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b0c304","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tips.vue
// module id = null
// module chunks = 